import { Component, OnInit, Optional } from '@angular/core'
import { CmsSearchBoxComponent, RoutingService, WindowRef } from '@spartacus/core'
import { CmsComponentData, SearchBoxComponent, SearchBoxComponentService, SearchBoxConfig } from '@spartacus/storefront'
import { Observable, of } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { ICustomSearchResults } from '../../../models/interface/search-results.interface'
import { CustomSearchBoxComponentService } from '../../../services/custom-search-box-component.service'
import { UserPermissionService } from '../../../services/user-permission/user-permission.service'

const DEFAULT_SEARCH_BOX_CONFIG: SearchBoxConfig = {
  minCharactersBeforeRequest: 1,
  displayProducts: true,
  displaySuggestions: true,
  maxProducts: 5,
  maxSuggestions: 5,
  displayProductImages: true
}
@Component({
  selector: 'app-custom-search-box',
  templateUrl: './custom-search-box.component.html',
  styleUrls: ['./custom-search-box.component.scss'],
  standalone: false
})
export class CustomSearchBoxComponent extends SearchBoxComponent implements OnInit {
  searchConfig$: Observable<SearchBoxConfig>
  declare results$: Observable<ICustomSearchResults>

  constructor(
    protected searchBoxComponentService: SearchBoxComponentService,
    @Optional()
    protected componentData: CmsComponentData<CmsSearchBoxComponent>,
    protected winRef: WindowRef,
    protected routingService: RoutingService,
    public userPermissionService: UserPermissionService,
    private customSearchBoxComponentService?: CustomSearchBoxComponentService
  ) {
    super(searchBoxComponentService, componentData, winRef, routingService)
  }

  ngOnInit(): void {
    this.searchConfig$ = (this.componentData?.data$ || of({} as any)).pipe(
      map((config: object) => {
        const isBool = (obj: SearchBoxConfig, prop: string): boolean => obj?.[prop] !== 'false' && obj?.[prop] !== false

        return {
          ...DEFAULT_SEARCH_BOX_CONFIG,
          ...config,
          displayProducts: isBool(config, 'displayProducts'),
          displayProductImages: isBool(config, 'displayProductImages'),
          displaySuggestions: isBool(config, 'displaySuggestions'),
          // we're merging the (optional) input of this component, but write the merged
          // result back to the input property, as the view logic depends on it.
          ...this.config
        }
      }),
      tap((config) => (this.config = config))
    )

    this.results$ = this.searchConfig$.pipe(
      switchMap((config) => this.customSearchBoxComponentService.customGetResults(config))
    )
  }
}
